import { RadioGroup } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import { Radio } from "@/react/components/shared/uikit/Radio";
import { useConfirmAccess } from "@/react/hooks/useConfirmAccessAction";

const localeRoot = "community_onboarding.new_checklist.confirm_access_section";

export const ConfirmAccessContent = () => {
  const { communityAccess, handleAccessChange } = useConfirmAccess();

  const options = [
    {
      label: t(`${localeRoot}.public.label`),
      value: "public",
      description: t(`${localeRoot}.public.description`),
    },
    {
      label: t(`${localeRoot}.private.label`),
      value: "private",
      description: t(`${localeRoot}.private.description`),
    },
  ];

  return (
    <div className="border-primary bg-tertiary mb-3 rounded-xl border p-6">
      <RadioGroup value={communityAccess} onChange={handleAccessChange}>
        <div className="flex flex-col gap-4">
          {options.map(option => (
            <RadioGroup.Option
              key={option.value}
              value={option.value}
              className="cursor-pointer"
            >
              {({ checked }) => (
                <Radio
                  id={`access-type-${option.value}`}
                  name="access-type"
                  label={option.label}
                  description={option.description}
                  checked={checked}
                  value={option.value}
                />
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};
